import React from 'react';
import ApprovalSubmittedV2Container from '../../containers/approvalmng/ApprovalSubmittedV2Container';

const ApprovalSubmittedPage = () => {
  return <ApprovalSubmittedV2Container />;
};

export default ApprovalSubmittedPage;
